"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendParentBack = exports.updateAppointment = exports.setRescheduleReasons = exports.sendParentSuccess = exports.sendParentExit = exports.selectRescheduleReason = void 0;
const xstate_1 = require("xstate");
const constants_1 = require("../../../lib/constants");
const setRescheduleReasons = '@action/SET_RESCHEDULE_REASONS';
exports.setRescheduleReasons = setRescheduleReasons;
const selectRescheduleReason = '@action/SELECT_RESCHEDULE_REASON';
exports.selectRescheduleReason = selectRescheduleReason;
const sendParentSuccess = '@action/SEND_PARENT_SUCCESS';
exports.sendParentSuccess = sendParentSuccess;
const updateAppointment = '@action/UPDATE_APPOINTMENT';
exports.updateAppointment = updateAppointment;
const sendParentExit = '@action/SEND_PARENT_EXIT';
exports.sendParentExit = sendParentExit;
const sendParentBack = '@action/SEND_PARENT_BACK';
exports.sendParentBack = sendParentBack;
const actions = {
    // Sets reschedule reasons
    [setRescheduleReasons]: (0, xstate_1.assign)({
        rescheduleReasons: (_, event) => event.data
    }),
    // Sends event and data to parent
    // for exit condition when user wants to keep original appointment
    [sendParentExit]: (0, xstate_1.sendParent)((_) => ({
        type: constants_1.events.KEEP_ORIGINAL_APPOINTMENT,
        context: {
            keepOriginalAppointment: true
        }
    })),
    // Selects reschedule reason
    [selectRescheduleReason]: (0, xstate_1.assign)({
        selectedRescheduleReason: (_, event) => event.data
    }),
    // Sends event and data to parent for successful rescheduling
    [sendParentSuccess]: (0, xstate_1.sendParent)((context) => ({
        type: constants_1.events.RESCHEDULED,
        context: {
            appointment: context.appointment
        }
    })),
    // Updates appointment data stored in context
    [updateAppointment]: (0, xstate_1.assign)({
        appointment: (context, event) => (Object.assign(Object.assign({}, context.appointment), event.data.data.rescheduled_appointment))
    }),
    [sendParentBack]: (0, xstate_1.sendParent)(() => {
        return {
            type: constants_1.events.GO_BACK
        };
    })
};
exports.default = actions;
//# sourceMappingURL=actions.reasonMachine.js.map